export default __webpack_public_path__ + "media/transfer_window/transfer_password-58345318.mp4";